import React from 'react';

const CodeBlockOptions = ({ editor }) => {
  return (
    <div className="codeBlockOptions">
      <h3>Code Block</h3>
      {/* Options will be added later */}
    </div>
  );
};

export default CodeBlockOptions;
